/**
 * 店舗選択の階層情報から対象の店舗IDリストを解決するユーティリティ
 *
 * 「全店舗」選択時に、組織階層を辿って該当する全店舗のIDを収集する。
 * 動的な組織ツリー（parent_organization_id ベース）に対応。
 */
import { fetchStores } from "../../api/stores";
import { ALL_SELECTION_ID, type StoreSelectionState } from "../../app/store/storeSelectionSlice";

/**
 * StoreSelectionState から組織階層を辿り、対象の店舗IDリストを解決する。
 *
 * - 「全店舗」でない場合は単一の store.id を返す
 * - 「全店舗」の場合は全店舗IDを返す（TODO: 組織と店舗の紐付け後に絞り込みを実装）
 */
export async function resolveStoreIdsForSelection(
    selection: StoreSelectionState,
): Promise<number[]> {
    // 具体的な店舗が選択されている場合
    if (selection.store && selection.store.id !== ALL_SELECTION_ID) {
        return [selection.store.id];
    }

    // 「全店舗」モード: 全店舗を返す
    const stores = await fetchStores();
    return stores.items.map(s => s.id);
}
